/** 统一项目库静态 JSON 加载 */

import type { MarketProject, ProjectCategory } from '../types/market';

const PROJECT_LIBRARY_URL = `${process.env.PUBLIC_URL || ''}/data/projectLibrary.json`;

function toNullableNumber(v: unknown): number | null {
  if (v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function toStringField(v: unknown): string {
  if (v === null || v === undefined) return '';
  return String(v).trim();
}

/** 港澳台及内地省份不应标为海外（兼容旧 JSON 误标） */
function normalizeCategory(value: unknown): ProjectCategory {
  return value === 'performance' ? 'performance' : 'preliminary';
}

function normalizeProject(raw: unknown): MarketProject {
  const r = raw as Record<string, unknown>;
  const id = toStringField(r.id);
  return {
    id,
    // 兼容早期数据：缺少 code 字段时，项目编号即 id；新数据里空串表示未编号
    code: r.code === undefined ? id : toStringField(r.code),
    name: toStringField(r.name),
    category: normalizeCategory(r.category),
    isNonEnergyPower: Boolean(r.isNonEnergyPower),
    industry: toStringField(r.industry),
    businessType: toStringField(r.businessType),
    location: toStringField(r.location),
    province: toStringField(r.province),
    city: toStringField(r.city),
    region: toStringField(r.region),
    client: toStringField(r.client),
    leader: toStringField(r.leader),
    owner: toStringField(r.owner),
    department: toStringField(r.department),
    contractAmountWan: toNullableNumber(r.contractAmountWan),
    overview: toStringField(r.overview),
    latitude: toNullableNumber(r.latitude),
    longitude: toNullableNumber(r.longitude),
    isOverseas: Boolean(r.isOverseas),
    country: toStringField(r.country),
  };
}

export async function fetchAllMarketProjects(): Promise<MarketProject[]> {
  const res = await fetch(PROJECT_LIBRARY_URL);
  if (!res.ok) {
    throw new Error(`加载项目库失败: ${res.status}`);
  }
  const data: unknown = await res.json();
  if (!Array.isArray(data)) {
    throw new Error('项目库数据格式错误');
  }
  return data.map(normalizeProject).filter((project) => project.id && project.name);
}
